import { stringToDate } from '@dxb-web-ui-framework/common/utils/Date';
import { subMinutes, subMonths } from 'date-fns';
import { ConsolidatedTransactionListFilters, ConsolidatedTransactionsProviderState } from './types';

const initialConsolidatedTransactionListFilters = {
  pageSize: 10,
  pageOffset: 0,
  fromTrxDate: stringToDate({ date: subMonths(new Date(), 2).toISOString(), formatExp: "yyyy-MM-dd'T'00:00:00" }),
  toTrxDate: stringToDate({
    date: subMinutes(new Date(), 1).toISOString(),
    formatExp: "yyyy-MM-dd'T'HH:mm:00",
    tz: 'UTC',
  }),
};

const defaultConsolidatedTransactionsProviderState: ConsolidatedTransactionsProviderState = {
  consolidatedTransactionListData: null,
  consolidatedTransactionListFilters: initialConsolidatedTransactionListFilters,
  resetConsolidatedTransactionsListFilters: () => {},
  onConsolidatedTransactionListFiltersChange: (
    filters: Partial<ConsolidatedTransactionListFilters>,
    nextPage?: number,
    totalPages?: number,
  ) => {},
  refetchConsolidatedTransactionList: () => {},
  loadingState: {
    isLoadingConsolidatedTransactionList: false,
  },
  errorState: {
    consolidatedTransactionListError: undefined,
  },
  lastPaginationPageVisited: 1,
  onSetLastPaginationPageVisited: (value: number) => {},
};

export { defaultConsolidatedTransactionsProviderState, initialConsolidatedTransactionListFilters };
